export default __webpack_public_path__ + "static/media/physics-card-bg.a515046c.svg";